import { render, staticRenderFns } from "./CarouselItem.vue?vue&type=template&id=d2aaa64c&scoped=true&"
import script from "./CarouselItem.vue?vue&type=script&lang=js&"
export * from "./CarouselItem.vue?vue&type=script&lang=js&"
import style0 from "./CarouselItem.vue?vue&type=style&index=0&id=d2aaa64c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2aaa64c",
  null
  
)

export default component.exports